module.exports = __webpack_public_path__ + "img/bp.aadac7ce.png";